import { useCallback } from "react";
import {
  createTicketStatus,
  deleteTicketStatusDefinition,
  listTicketStatuses,
  updateTicketStatusDefinition,
} from "../service/CallCenterTickets";
import { useAsyncAction } from "./useAsyncAction";

export const useTicketStatuses = () => {
  const state = useAsyncAction([]);

  const list = useCallback(
    async (options) => state.run(() => listTicketStatuses(options)),
    [state]
  );
  const create = useCallback(
    async (payload) => state.run(() => createTicketStatus(payload)),
    [state]
  );
  const update = useCallback(
    async (payload) => state.run(() => updateTicketStatusDefinition(payload)),
    [state]
  );
  const remove = useCallback(
    async (id) => state.run(() => deleteTicketStatusDefinition(id)),
    [state]
  );

  return {
    ...state,
    list,
    create,
    update,
    remove,
  };
};
